"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.personNoSchoolTripReasonSpecify = exports.personNoSchoolTripIntro = exports.personNoWorkTripReasonSpecify = exports.personNoWorkTripIntro = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const escape_1 = __importDefault(require("lodash/escape"));
const i18n_config_1 = __importDefault(require("evolution-frontend/lib/config/i18n.config"));
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const widgetsSwitchPerson_1 = require("evolution-common/lib/services/questionnaire/sections/common/widgetsSwitchPerson");
const customConditionals = __importStar(require("../../common/customConditionals"));
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const switchPersonWidgets = (0, widgetsSwitchPerson_1.getSwitchPersonWidgets)();
exports.activePersonTitle = switchPersonWidgets.activePersonTitle;
exports.buttonSwitchPerson = switchPersonWidgets.buttonSwitchPerson;
exports.personNoWorkTripIntro = {
    type: 'text',
    containsHtml: true,
    text: (t, interview) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        const assignedDate = (0, frontendHelper_1.getFormattedDate)((0, helpers_1.getResponse)(interview, '_assignedDay'), {
            withRelative: false,
            locale: i18n_config_1.default.language,
            withDayOfWeek: false
        });
        return t('travelBehavior:personNoWorkTripIntro', {
            nickname,
            assignedDate,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    conditional: customConditionals.shouldAskForNoWorkTripReasonCustomConditional
};
exports.personNoWorkTripReasonSpecify = Object.assign(Object.assign({}, defaultInputBase.inputStringBase), { path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noWorkTripReasonSpecify', twoColumns: false, containsHtml: true, label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const assignedDate = (0, frontendHelper_1.getFormattedDate)((0, helpers_1.getResponse)(interview, '_assignedDay'), {
            withRelative: false,
            locale: i18n_config_1.default.language,
            withDayOfWeek: false
        });
        return t('travelBehavior:household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noWorkTripReasonSpecify', {
            nickname,
            assignedDate,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person: activePerson })
        });
    }, conditional: customConditionals.shouldAskPersonNoWorkTripSpecifyCustomConditional, validations: validations.optionalValidation });
exports.personNoSchoolTripIntro = {
    type: 'text',
    containsHtml: true,
    text: (t, interview) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        const assignedDate = (0, frontendHelper_1.getFormattedDate)((0, helpers_1.getResponse)(interview, '_assignedDay'), {
            withRelative: false,
            locale: i18n_config_1.default.language,
            withDayOfWeek: false
        });
        return t('travelBehavior:personNoSchoolTripIntro', {
            nickname,
            assignedDate,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    conditional: customConditionals.shouldAskForNoSchoolTripReasonCustomConditional
};
exports.personNoSchoolTripReasonSpecify = Object.assign(Object.assign({}, defaultInputBase.inputStringBase), { path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noSchoolTripReasonSpecify', twoColumns: false, containsHtml: true, label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const assignedDate = (0, frontendHelper_1.getFormattedDate)((0, helpers_1.getResponse)(interview, '_assignedDay'), {
            withRelative: false,
            locale: i18n_config_1.default.language,
            withDayOfWeek: false
        });
        return t('travelBehavior:household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noSchoolTripReasonSpecify', {
            nickname,
            assignedDate,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person: activePerson })
        });
    }, conditional: customConditionals.shouldAskForNoSchoolTripSpecifyCustomConditional, validations: validations.optionalValidation });
